module.exports = __webpack_public_path__ + "img/mouse.11cb666e.svg";